import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PageHeader, StatusPill } from "@/components/common";
import { api, fmtDate } from "@/lib/api";
import AgencyDrawer from "./AgencyDrawer";

export default function Agencies() {
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState([]);
  const [active, setActive] = useState(null);
  const load = () => api.get("/admin/agencies", { params: { search } }).then((r) => setRows(r.data)).catch(() => toast.error("Failed to load agencies"));

  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <div>
      <PageHeader eyebrow="Accounts" title="Agencies" subtitle="Manage agency accounts, access, credits and subscriptions." />
      <div className="relative mb-4 max-w-md"><Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input className="pl-9" placeholder="Search agencies" value={search} onChange={(e) => setSearch(e.target.value)} data-testid="agencies-search" /></div>
      <div className="bg-card rounded-xl border overflow-x-auto fade-up">
        <Table data-testid="agencies-table">
          <TableHeader><TableRow><TableHead>Agency</TableHead><TableHead>Owner</TableHead><TableHead>Credits</TableHead><TableHead>Subscription</TableHead><TableHead>Unlocks</TableHead><TableHead>Status</TableHead><TableHead>Joined</TableHead><TableHead /></TableRow></TableHeader>
          <TableBody>
            {rows.map((a) => (
              <TableRow key={a.id} data-testid={`agency-row-${a.id}`}>
                <TableCell className="font-medium min-w-[160px]">{a.name}<p className="text-xs text-muted-foreground">{a.country}</p></TableCell>
                <TableCell className="text-sm min-w-[180px]">{a.owner_name}<p className="text-xs text-muted-foreground">{a.owner_email}</p></TableCell>
                <TableCell className="font-mono" data-testid={`agency-credits-${a.id}`}>{a.credit_balance}</TableCell>
                <TableCell className="text-sm">{a.subscription ? <>{a.subscription.plan_name}<p className="text-xs text-muted-foreground">until {fmtDate(a.subscription.end_at)}</p></> : <span className="text-muted-foreground">—</span>}</TableCell>
                <TableCell className="font-mono">{a.unlock_count}</TableCell>
                <TableCell><StatusPill status={a.status} testId={`agency-status-${a.id}`} /></TableCell>
                <TableCell className="text-sm whitespace-nowrap">{fmtDate(a.created_at)}</TableCell>
                <TableCell><Button size="sm" variant="outline" onClick={() => setActive(a.id)} data-testid={`agency-manage-${a.id}`}>Manage</Button></TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && <TableRow><TableCell colSpan={8} className="text-center text-muted-foreground py-10">No agencies yet</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
      <AgencyDrawer agencyId={active} onClose={() => setActive(null)} onChanged={load} />
    </div>
  );
}
